import { useEffect, useState } from 'react';
import { useApp } from '../store.js';

/** Связь с игрой потеряна дольше 0,8 с — оверлей поверх любого экрана (короткие обрывы не мигают). */
export function ReconnectOverlay() {
  const reconnecting = useApp((s) => s.session === 'ready' && s.reconnecting);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!reconnecting) {
      const id = setTimeout(() => setVisible(false), 0);
      return () => clearTimeout(id);
    }
    const id = setTimeout(() => setVisible(true), 800);
    return () => clearTimeout(id);
  }, [reconnecting]);
  if (!visible) return null;
  return (
    <div className="overlay" role="alert">
      <div className="overlay__spinner" aria-hidden="true">
        ⚽
      </div>
      <p>Связь потеряна, переподключаемся…</p>
      <p className="overlay__hint">Матч продолжится с того же места — у вас есть 20 секунд</p>
    </div>
  );
}
